import { ReactElement } from 'react';
import { Box, Typography, Grid, useTheme, useMediaQuery } from '@mui/material';
import { Formik } from 'formik';
import { ForgotPasswordSchema } from 'validators/AuthenticationShema';

import {
    AppFormikTextField,
    AppPrimaryButton,
} from 'shared/components/AppComponents';
import { Utils } from 'shared/helpers';
import { NavLink } from 'react-router-dom';
import { AuthenticationService } from 'services';

const ForgotPasswordForm = (): ReactElement => {
    const forgotPasswordForm = {
        email: '',
    };

    const theme = useTheme();
    const match = useMediaQuery(theme.breakpoints.down('md'));

    // API Calls
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const forgotPassword = (formValues: any, callback: any): void => {
        AuthenticationService.forgetPassword(formValues.email)
            .then((response: any) => {
                callback(true, response);
            })
            .catch((error: any) => {
                callback(false);

                Utils.handleErrorResponse(error);
            });
    };

    // UI Actions
    const actionOnFormSubmit = (formValues: any, formik: any): void => {
        forgotPassword({ ...formValues }, (status: any, response: any) => {
            formik.setSubmitting(false);
            if (status) {
                formik.resetForm();
                Utils.handleSuccessResponse(response);
            }
        });
    };

    // UI Elements
    return (
        <Box className="forgot-password-form-wrapper">
            <Typography className="title" variant="h2">
                Forgotten Password?
            </Typography>
            <Typography className="subtitle-line-1" variant="body1">
                Enter your email to reset your password.
            </Typography>
            <Typography className="subtitle-line-2" variant="body1">
                Remember Password ?
                <Typography
                    to="/login"
                    className="subtitle-link"
                    component={NavLink}
                    variant="body1"
                >
                    Login
                </Typography>
            </Typography>

            <Box pt={7}>
                <Formik
                    enableReinitialize
                    initialValues={forgotPasswordForm}
                    validationSchema={ForgotPasswordSchema}
                    validateOnMount
                    onSubmit={(formValues, formik) => {
                        actionOnFormSubmit(formValues, formik);
                    }}
                >
                    {({ handleSubmit, isSubmitting, isValid }) => (
                        <form autoComplete="off">
                            <Box mt={2}>
                                <AppFormikTextField
                                    outerLabel
                                    label="Email *"
                                    name="email"
                                    placeholder="Type here"
                                />
                            </Box>

                            <Box pt={6}>
                                <Grid
                                    container
                                    spacing={1}
                                    direction={match ? 'column-reverse' : 'row'}
                                >
                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={6}
                                        className="flex start-content"
                                    >
                                        <Typography
                                            className="info"
                                            variant="body1"
                                        >
                                            We will send the instructions to the
                                            email filled above
                                        </Typography>
                                    </Grid>

                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={6}
                                        className="end-content"
                                    >
                                        <AppPrimaryButton
                                            className="p-3"
                                            testid="button-forgot"
                                            fullWidth
                                            title="Submit"
                                            isLoading={isSubmitting}
                                            loadingSize={22}
                                            disabled={isSubmitting || !isValid}
                                            onClick={handleSubmit}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </form>
                    )}
                </Formik>
            </Box>
        </Box>
    );
};

export default ForgotPasswordForm;
